hrd.GeolocationMap = hrd.AbstractCommonInterface.extend({
	/** @type JQuery */
	$field: null,
	/** @type  google.maps.Map */
	map: null,
	/** @type  google.maps.Marker */
	marker: null,

	init: function($field, options) {
		this.prepareField($field, options)
			.then(() => this.initMap(options))
			.then((map, marker) => {
				this.map = map;
				this.marker = marker;
			});
	},
	prepareField: function($field, options) {
		let promise;
		this.$field = $field;
		if (!window.google) {
			this.$field
				.closest('.field-composite')
				.remove();
			promise = $.never();
		} else {
			this.$field.addClass('do-not-touch-inner-buttons');
			promise = $.when();
		}
		return promise;
	},
	initMap: function(options) {
		return initGeolocationMap(this.$field.get(0), options);
	},
	getLocation: function() {
		if (!this.map || !this.marker) return;

		const center = this.map.getCenter();

		return { lat: center.lat(), lng: center.lng() };
	},
	setLocation: function(location) {
		if (!this.map || !this.marker) return;

		const loc = $.extend({}, { lat: 41.902782, lng: 12.496366 }, location);
		this.map.setCenter(loc);
		this.marker.setPosition(loc);
	}
});